module.exports = __webpack_public_path__ + "assets/img/main-summary-arrow.3bd4fb2d.svg";